const PREFIX = process.env.VUE_APP_API;
const PASSPORT_PREFIX = "https://passport" + process.env.VUE_APP_DOMAIN;
const AUTH_PREFIX = "https://auth" + process.env.VUE_APP_DOMAIN;

export default {
  userInfo: `${PASSPORT_PREFIX}/api/setting/profile`,

  userList: `${PREFIX}/api/user/list`,

  authPermissions: `${AUTH_PREFIX}/api/admin/user_permissions`,
};
